angular.module('dentalLinks')
    .controller('FindPracticeController', ['$scope', 'Practice', 'User', 'ProviderInvitation', '$q', 'ReferralHelper',
        function ($scope, Practice, User, ProviderInvitation, $q, ReferralHelper) {
            /**
             * For a given search term, looks for relevant practices and invitations,
             * so that create_referral screen could show user this list.
             */
            $scope.findPractice = function (searchValue) {
                if($scope.model.referral.isCreatedNow) {
                    $scope.tempDestinationPractice = $scope.destinationPractice;
                }
                $scope.destinationPractice = [];
                var providersPromise = Practice.searchPractice({search: searchValue}).$promise;
                var invitationsPromise = ProviderInvitation.query({search: searchValue}).$promise;
                return $q.all([providersPromise, invitationsPromise]).then(function (results) {

                    var practices = [];
                    var length = results[0].length;
                    for (var i = 0; i < length; i++) {
                        var p = results[0][i];
                        practices.push(JSON.parse(JSON.stringify(p)));   // todo: a more efficient way of cloning than by stringifying and parsing - might exist
                    }

                    var invitations = results[1].map(function (invitation) {
                        invitation.roles_mask = 2;
                        return {users: [invitation], name: '-- pending registration (' + invitation.email + ') --', isInvitation: true};
                    });
                    return practices.concat(invitations);
                });
            };

            $scope.onPracticeSelected = function (practice) {
                // this triggers refresh of items in provider dropdown
                $scope.destinationPractice = practice;

                $scope.practiceSearchText = $scope.destinationPractice.name;

                if($scope.destinationPractice.addresses && $scope.destinationPractice.addresses.length == 1) {
                    $scope.model.referral.address_id = $scope.destinationPractice.addresses[0].id;
                }
                if (practice.isInvitation) {
                    $scope.model.referral.dest_provider_invited_id = practice.users[0].id;
                    $scope.model.referral.dest_provider_id = null;
                } else {
                    // TODO: this is only used in create_referral page, where user is logged in. Should switch to using a protected API call here.
                    $scope.destinationPractice.users = User.getOtherProviders({practice_id: practice.id}, function(users){
                        $scope.model.referral.dest_provider_invited_id = null;
                        if (users.length == 1) {
                            $scope.model.referral.dest_provider_id = users[0].id;
                        }
                        users.unshift({id: -1, first_name: 'First', last_name: 'Available', firstAvailable: true});

                    });
                }
                // select default referral type from practice type
                ReferralHelper.updatePracticeType($scope, practice.practice_type_id);
            };
        }]);
